<template>
  <div class="filter-container">
    <FilterList
      ref="filterList"
      isJobApplicantList
      hiddenMyCandidateSwitch
      class="applicant-list"
      :candidateList="candidateList"
      :listLoading="listLoading"
      :searchTemplate.sync="searchTemplate"
      :searchTemplateList="searchTemplateList"
      :filterGroupList="filterList"
      :actionList="actionList"
      :addBtnList="addBtnList"
      :operationList="operationList"
      :candidateTotalCount="candidateTotalCount"
      :currentSelectedCount="currentSelectedCount"
      :pagination="pagination"
      :jobName="jobName"
      :hasSoftUserPermission="hasSoftUserPermission"
      @selectedChange="handleSelectedChange"
      @selectAll="handleSelectAll"
      @search="handelSearch"
      @scrollBottom="handleScrollBottom"
      @orderChange="handleOrderChange"
      @openDetail="handleOpenDetail"
      @createSearchTemplate="handleCreateSearchTemplate"
      @updateSearchTemplate="handleUpdateSearchTemplate"
      @clearSearchTemplate="handleClearSearchTemplate"
      @deleteSearchTemplate="handleDeleteSearchTemplate"
      @selectAllCard="handleSelectAllCard"
      @scrollToTop="handleScrollToTop"
    >
      <template #tableContainer>
        <TableList
          ref="tableContainer"
          :data="candidateList"
          :cancelSelectedCandidateList="cancelSelectedCandidateList"
          :operationList="operationList"
          :loading="listLoading"
          :showProblemSolvingFit="showProblemSolvingFit"
          :showAssessmentFit="showAssessmentFit"
          @selectedChange="handleSelectedChange"
          @selectAll="handleSelectAll"
          @scrollBottom="handleScrollBottom"
          @orderChange="handleOrderChange"
          @openDetail="handleOpenDetail"
        ></TableList>
      </template>
      <template #cardContainer>
        <CardList
          ref="cardContainer"
          :data="candidateList"
          :operationList="operationList"
          :loading="listLoading"
          :showProblemSolvingFit="showProblemSolvingFit"
          :showAssessmentFit="showAssessmentFit"
          :statusGroupList="statusGroupList"
          :showChannel="false"
          :showStatus="false"
          :showQuicklyChangeStatus="false"
          @selectedChange="handleSelectedChange"
          @selectAll="handleSelectAll"
          @scrollBottom="handleScrollBottom"
          @orderChange="handleOrderChange"
          @openDetail="handleOpenDetail"
        ></CardList>
      </template>
    </FilterList>
    <!-- <InviteHmRatingDialog
      ref="inviteHmRatingDialog"
      :applicationList="ratingDialog.applicationList"
      :isAllApplication="ratingDialog.isSelectAll"
      :searchParams="searchParams"
      @sent="handleSentHmRatingInvite"
    >
    </InviteHmRatingDialog>
    <InviteInterviewDialog
      ref="inviteInterviewDialog"
      :applicationList="interviewDialog.applicationList"
      :isAllApplication="interviewDialog.isSelectAll"
      :searchParams="searchParams"
      @sent="handleSentInterviewInvite"
    >
    </InviteInterviewDialog> -->
    <CopyCandidateDialog
      ref="copyCandidateDialog"
      isAgency
      :applicationList="copyCandidateDialog.applicationList"
      :isAllApplication="copyCandidateDialog.isSelectAll"
      :jobId="jobId"
      :searchParams="searchParams"
    ></CopyCandidateDialog>
    <!-- <ChangeCandidateStatusDialog
      ref="changeCandidateStatusDialog"
      :defaultStatus="changeCandidateStatusDialog.defaultStatusKey"
      :isAllApplication="changeCandidateStatusDialog.isSelectAll"
      :applicationList="changeCandidateStatusDialog.applicationList"
      :loadedStatusList="statusList"
      :jobId="jobId"
      :searchParams="searchParams"
      @success="handleChangeStatusSuccess"
    ></ChangeCandidateStatusDialog> -->
    <!-- <InviteOpenQuestionDialog
      ref="inviteQuestionDialog"
      :jobId="jobId"
      :isAllApplication="questionDialog.isSelectAll"
      :applicationList="questionDialog.applicationList"
      :searchParams="searchParams"
    /> -->
    <!-- <InviteOnboardingDialog
      ref="inviteOnboardingDialog"
      :jobId="jobId"
      :isAllApplication="onboardingDialog.isSelectAll"
      :applicationList="onboardingDialog.applicationList"
      :searchParams="searchParams"
    />
    <InviteSatisfactionDialog
      ref="inviteSatisfactionDialog"
      :jobId="jobId"
      :isAllApplication="satisfactionDialog.isSelectAll"
      :applicationList="satisfactionDialog.applicationList"
      :searchParams="searchParams"
    /> -->
    <!-- <InvitePortalDialog
      ref="invitePortalDialog"
      :jobId="jobId"
      :isAllApplication="portalDialog.isSelectAll"
      :applicationList="portalDialog.applicationList"
      :searchParams="searchParams"
    /> -->
    <!-- <AddCandidateToGroupVue
      ref="addGroupDialog"
      :groupList="groupList"
      :talentPoolGroupList="[]"
      :isOperator="addCandidateGroupDialog.isOperator"
      :hiddenTalentPoolGroup="true"
      @save="saveAddedGroup"
      @saveOperator="handleSaveOperatorCandidateToGroup"
    />
    <MoveGroupDialog
      ref="moveGroupDialog"
      :groupList="groupList"
      :selectedGroupList="groupList"
      :isOperator="moveCandidateGroupDialog.isOperator"
      :i18nTitleKey="'move'"
      @save="handleSaveMovedGroup"
      @saveOperator="handleSaveOperatorMovedGroup"
    ></MoveGroupDialog>
    <MoveGroupDialog
      ref="removedGroupDialog"
      :isRemoved="true"
      :selectedGroupList="groupList"
      :isOperator="removeCandidateGroupDialog.isOperator"
      :i18nTitleKey="'remove'"
      @save="handleSaveRemovedGroup"
      @saveOperator="handleSaveOperatorRemovedGroup"
    ></MoveGroupDialog>
    <ExportCandidateAllInfoDialog
      ref="exportCandidateAllInfoDialog"
      :exportInfo="exportInfo"
      :isOperator="exportCandidateAllInfoDialog.isOperator"
      @save="saveExportCandidateAllInfo"
      @saveOperator="handleSaveOperatorExportCandidateAllInfo"
    ></ExportCandidateAllInfoDialog> -->
    <!-- <ContactCandidate
      ref="contactDialog"
      :jobId="jobId"
      :candidateIds="contactDialog.candidateIds"
      :isAllCandidate="contactDialog.isSelectAll"
      :searchParams="searchParams"
    /> -->
    <!-- <AddTagDialog
      ref="addTagDialog"
      :jobId="jobId"
      :candidateList="addTagDialog.candidateList"
      :isAllApplication="addTagDialog.isSelectAll"
      :searchParams="searchParams"
    ></AddTagDialog> -->
    <!-- <AddComment
      ref="addCommentDialog"
      :jobId="jobId"
      :candidateId="commentDialog.candidateId"
    /> -->
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { addI18nProperty, createI18nProperty, getConstantI18nValue, getI18nPropertyValue } from '@/i18n'
import { SQUARED_UP_MAP, STATUS_STAGE, READ_STATUS, ASSESSMENT_INVITE_TYPE, MUNICIPALITY_CITY, MUNICIPALITY_PROVINCE, GENDER, CONSENT_STATUS, PROBLEM_SOLVING_FIT_RANGE_BAR } from '@/constant/application'
import { DEGREE } from '@/constant/meta'
import { HAS_OPTIONS_QUESTION_TYPES } from '@/constant/openQuestion'
import { AsyncTask } from '@/utils/common'
import { formatBigNumber } from '@/components/filters'
import FilterList from '../../adminNew/applicantList/filterList/layout.vue'
// import ChangeCandidateStatusDialog from '../applicantList/dialog/changeCandidateStatus.vue'
import DateRage from '../../adminNew/applicantList/dateRange.vue'
import RangeSelect from '../../adminNew/applicantList/rangeSelect.vue'
import CopyCandidateDialog from '../../adminNew/applicantList/dialog/copyCandidateDialog.vue'
// import InviteHmRatingDialog from '../../adminNew/applicantList/dialog/inviteHmRating.vue'
// import InviteInterviewDialog from '../../adminNew/applicantList/dialog/inviteInterview.vue'
// import TagSelect from '../applicantList/tagSelect.vue'
import AssessmentFitChart from '../../adminNew/jobApplicantList/assmentFitChart.vue'
import ProblemSolvingFitChart from '../../adminNew/jobApplicantList/problemSolvingChart.vue'
// import InviteOpenQuestionDialog from '../../adminNew/candidate/profile/dialog/inviteOpenQuestion.vue'
// import InviteOnboardingDialog from '../../adminNew/candidate/profile/dialog/inviteOnboardingQuestionnaire.vue'
// import InviteSatisfactionDialog from '../../adminNew/candidate/profile/dialog/inviteSatisfactionQuestionnaire.vue'
// import InvitePortalDialog from '../../adminNew/candidate/profile/dialog/invitePortalQuestionnaire.vue'
// import MoveGroupDialog from '../../adminNew/applicantList/dialog/moveCandidateGroup.vue'
// import AddCandidateToGroupVue from '../../adminNew/candidate/profile/dialog/addGroupDialog.vue'
// import ExportCandidateAllInfoDialog from '../../adminNew/applicantList/dialog/exportCandidateAllInfo.vue'
// import ContactCandidate from '../../adminNew/candidate/profile/dialog/contactCandidate.vue'
import CardList from '../../adminNew/application/job/card.vue'
import TableList from './filterList/candidateList.vue'
// import GroupSelect from '../../adminNew/applicantList/groupSelect.vue'
// import AddTagDialog from '../../adminNew/applicantList/dialog/addTagDialog.vue'
// import AddComment from '@/views/adminNew/candidate/profile/dialog/addComment.vue'
import { FILTER_GROUP_TYPE } from '@/constant/company'
import WorkCompanyName from '@/views/adminNew/applicantList/workCompanyName.vue'

// const CANDIDATE_TYPE = {
//   EMPLOYEE: 'EMPLOYEE',
//   CANDIDATE: 'CANDIDATE'
// }

// const PARENT_FIELD_NAME_LIST = {
//   CANDIDATE_INFO: 'PersonalInfo',
//   APPLICATION_INFO: 'ApplicationInfo',
//   FITNESS_INFO: 'FitnessInfo',
//   ASSESSMENT_INFO: 'AssessmentInfo',
//   INTERN_EXP_INFO: 'InternExperienceInfo',
//   WORK_EXP_INFO: 'ExperienceInfo',
//   EDUCATION_EXP_INFO: 'EducationInfo',
//   ADDITIONAL_INFO: 'AdditionalInfo',
//   LANGUAGE_INFO: 'LanguageInfo',
//   JOB_SURVEY: 'jobSurveyInfo',
//   CANDIDATE_CONSENT_INFO: 'candidateConsentInfo'
// }

// const FILTER_GROUP_TYPE = {
//   ASSESSMENT_FIT: 'ASSESSMENT_FIT',
//   PROBLEM_SOLVING_FIT: 'PROBLEM_SOLVING_FIT',
//   SOURCE: 'SOURCE',
//   APPLICATION_DETAIL: 'APPLICATION_DETAIL',
//   PROFILE_DETAIL: 'PROFILE_DETAIL'
// }

const SELECT_ALL_CANDIDATE_LIMIT = {
  ADD_TAG: 20000
}

export default {
  components: {
    FilterList,
    // ChangeCandidateStatusDialog,
    CopyCandidateDialog,
    // InviteHmRatingDialog,
    // InviteInterviewDialog,
    // InviteOpenQuestionDialog,
    // InviteOnboardingDialog,
    // InviteSatisfactionDialog,
    // InvitePortalDialog,
    // AddCandidateToGroupVue,
    // MoveGroupDialog,
    // ExportCandidateAllInfoDialog,
    // ContactCandidate,
    TableList,
    CardList
    // AddTagDialog,
    // AddComment
  },
  data () {
    const vm = this
    return {
      i18nPrefix: 'admin.application.applicantList',
      pagination: {
        page: 1,
        pageSize: 20,
        totalPage: 2
      },
      listOrder: {
        prop: 'apply_time',
        order: '-'
      },
      searchTemplate: null,
      searchTemplateList: [],
      savedFilterList: [],
      candidateList: [],
      listLoading: false,
      isSelectedAllCandidate: false,
      isSelectedAllCardCandidate: false,
      selectedCandidateList: [],
      ratingDialog: {
        isSelectAll: false,
        applicationList: []
      },
      interviewDialog: {
        applicationList: [],
        isSelectAll: false
      },
      copyCandidateDialog: {
        isSelectAll: false,
        applicationList: []
      },
      changeCandidateStatusDialog: {
        isSelectAll: false,
        applicationList: []
      },
      questionDialog: {
        isSelectAll: false,
        applicationList: []
      },
      contactDialog: {
        isSelectAll: false,
        candidateIds: []
      },
      commentDialog: {
        isSelectAll: false,
        candidateId: null
      },
      onboardingDialog: {
        isSelectAll: false,
        applicationList: []
      },
      satisfactionDialog: {
        isSelectAll: false,
        applicationList: []
      },
      portalDialog: {
        isSelectAll: false,
        applicationList: []
      },
      ORQuestionDialog: {
        isSelectAll: false,
        applicationList: []
      },
      addCandidateGroupDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      moveCandidateGroupDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      removeCandidateGroupDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      exportCandidateAllInfoDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      addTagDialog: {
        isSelectAll: false,
        candidateList: []
      },
      searchedGroupList: [],
      groupList: [],
      isSavingSearchTemplate: false,
      location: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      school: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      major: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      candidateTotalCount: 0,
      jobName: null,
      job: null,
      nps: {
        value: 0,
        nValue: 0,
        inviteCount: 0,
        rate: 0
      },
      exportInfo: {
        loading: false,
        data: [{
          id: 'All',
          get i18nName () {
            return vm.$t('common.label.selectAll')
          },
          children: []
        }]
      },
      exportPdfStatus: {
        loading: false,
        task: null,
        finished: false
      },
      exportConsentStatus: {
        loading: false,
        task: null,
        finished: false
      },
      currentSelectedCount: 0,
      search: {},
      companyPolicyList: [],
      hasProblemSolvingRequired: null,
      hasAssessmentValueRequired: null,
      hasPersonalityRequired: null,
      searchParams: null,
      isElcOriginCompany: null,
      formatBigNumber,
      statusGroupList: [],
      statusList: [],
      cancelSelectedCandidateList: [],
      hasAssessmentPremium: false,
      hasAIResumeMatchPremium: false,
      hasPreferenceSurveyManagementPremium: false
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount']),
    jobId () {
      return this.$route.params.jobId
    },
    currentAccount () {
      return this.getCurrentAccount
    },
    hasExportConsentPermission () {
      return this.currentAccount?.root_company_id === 8223
    },
    // hadAddCandidatePermission () {
    //   return this.hasAnyPermission(['PERM_JOB_CANDIDATE_UPLOAD', 'PREMIUM_CANDIDATE_UPLOAD'])
    // },
    // hasPostApplicantPermission () {
    //   return this.hasAnyPermission('PREMIUM_POST_APPLICANT')
    // },
    hasInviteORQuestionPermission () {
      return this.isElcOriginCompany
    },
    hasPrescreenSurvey () {
      return this.hasAnyPermission('PREMIUM_CHATBOT_PRESCREEN_SURVEY_MANAGEMENT')
    },
    hasAssessmentPermission () {
      return this.hasAssessmentPremium
    },
    hasSoftUserPermission () {
      return this.hasAnyPermission('PREMIUM_SOFT_USER')
    },
    hasCompanyPolicy () {
      return this.companyPolicyList.length > 0
    },
    showProblemSolvingFit () {
      return this.hasAssessmentPermission && this.hasProblemSolvingRequired
    },
    showAssessmentFit () {
      return this.hasAssessmentPermission && this.hasAssessmentValueRequired
    },
    hasAIResumeMatchPermission () {
      return this.hasAIResumeMatchPremium
    },
    applicantCountGroup () {
      const result = []
      _.forEach(STATUS_STAGE, (group, key) => {
        const groupInfo = this.getStatusInfo(group)
        const newGroupInfo = {
          count: formatBigNumber(groupInfo.count),
          name: _.lowerCase(key),
          label: this.$t(`${this.i18nPrefix}.label.${key}`),
          statusList: groupInfo.statusList
        }
        result.push(newGroupInfo)
      })
      return result
    },
    actionList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.copyCandidates`),
          handler: this.handleCopyCandidateAction
        }
      ]
      // list.push({
      //   label: this.$t(`${this.i18nPrefix}.btn.action.inviteAnswerQuestion`),
      //   handler: this.handleInviteQuestionAction
      // })
      // if (this.hasInviteOnboardingPermission) {
      //   list.push({
      //     label: this.$t(`${this.i18nPrefix}.btn.action.inviteOnboarding`),
      //     handler: this.handleInviteOnboardingAction
      //   })
      // }
      // if (this.hasPostApplicantPermission) {
      //   list.push({
      //     label: this.$t(`${this.i18nPrefix}.btn.action.invitePostApplicant`),
      //     handler: this.handleInvitePortalAction
      //   })
      // }
      // if (this.hasInviteORQuestionPermission) {
      //   list.push({
      //     label: this.$t(`${this.i18nPrefix}.btn.action.inviteAnswerORQuestion`),
      //     handler: this.handleInviteAnswerORQuestionAction
      //   })
      // }
      // list.push({
      //   label: this.$t(`${this.i18nPrefix}.btn.action.group`),
      //   hasChildren: true,
      //   childrenMenuList: [
      //     {
      //       label: this.$t('admin.application.candidateGroup.title.add'),
      //       handler: this.openAddGroupDialog
      //     },
      //     {
      //       label: this.$t('admin.application.candidateGroup.title.move'),
      //       handler: this.openMoveGroupDialog
      //     },
      //     {
      //       label: this.$t('admin.application.candidateGroup.title.remove'),
      //       handler: this.openRemoveGroupDialog
      //     }
      //   ]
      // })
      // list.push({
      //   label: this.$t(`${this.i18nPrefix}.btn.action.talentExport`),
      //   hasChildren: true,
      //   childrenMenuList: [
      //     {
      //       label: this.$t(`${this.i18nPrefix}.btn.action.exportAllCandidateInfo`),
      //       handler: this.handleExportCandidateAllInfo
      //     },
      //     {
      //       label: this.$t('admin.application.candidate.btn.resume'),
      //       handler: this.handleExportResume
      //     },
      //     {
      //       label: this.$t('admin.application.candidate.btn.report'),
      //       handler: this.handleExportReport
      //     },
      //     {
      //       label: this.$t('admin.application.candidate.btn.resumeAndReport'),
      //       handler: this.handleExportResumeAndReport
      //     },
      //     {
      //       hidden: !this.hasExportConsentPermission,
      //       label: this.$t('admin.application.candidate.btn.exportConsentInfo'),
      //       handler: this.handleExportConsentInfo
      //     }
      //   ]
      // })
      // if (this.hasAssessmentPermission) {
      //   list.push(
      //     {
      //       label: this.$t(`${this.i18nPrefix}.btn.action.inviteValueAndStrengthLabel`),
      //       handler: this.handleInvitePersonalityAction
      //     },
      //     {
      //       label: this.$t(`${this.i18nPrefix}.btn.action.inviteProblemSolveLabel`),
      //       handler: this.handleInviteProblemSolveAction
      //     }
      //   )
      // }
      return list
    },
    addBtnList () {
      const list = [
        {
          hidden: this.job.status !== '1',
          label: this.$t(`${this.i18nPrefix}.btn.uploadCandidate.single`),
          handler: this.handleUploadCandidateAction
        }
      ]
      return _.filter(list, item => !item.hidden)
    },
    operationList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.copyCandidate`),
          operator: this.handleCopyCandidateOperation
        }
      ]
      // list.push({
      //   label: this.$t(`${this.i18nPrefix}.btn.action.contact`),
      //   operator: this.handleContactOperation
      // })
      // if (this.hasInviteHMPermission) {
      //   list.push({
      //     label: this.$t(`${this.i18nPrefix}.btn.action.inviteHMRating`),
      //     operator: this.handleInviteHMRatingOperation
      //   })
      // }
      // if (this.hasInterviewPermission) {
      //   list.push({
      //     label: this.$t(`${this.i18nPrefix}.btn.action.inviteInterview`),
      //     operator: this.handleInviteInterviewOperation
      //   })
      // }
      // list.push({
      //   label: this.$t(`${this.i18nPrefix}.btn.action.inviteAnswerQuestion`),
      //   operator: this.handleInviteQuestionOperation
      // })
      // if (this.hasInviteOnboardingPermission) {
      //   list.push({
      //     label: this.$t(`${this.i18nPrefix}.btn.action.inviteOnboarding`),
      //     operator: this.handleInviteOnboardingOperation
      //   })
      // }
      // if (this.hasPostApplicantPermission) {
      //   list.push({
      //     label: this.$t(`${this.i18nPrefix}.btn.action.invitePostApplicant`),
      //     operator: this.handleInvitePortalOperation
      //   })
      // }
      // list.push({
      //   label: this.$t(`${this.i18nPrefix}.btn.action.group`),
      //   hasChildren: true,
      //   childrenMenuList: [
      //     {
      //       label: this.$t('admin.application.candidateGroup.title.add'),
      //       operator: this.openAddGroupDialogOperation
      //     },
      //     {
      //       label: this.$t('admin.application.candidateGroup.title.move'),
      //       operator: this.openMoveGroupDialogOperation
      //     },
      //     {
      //       label: this.$t('admin.application.candidateGroup.title.remove'),
      //       operator: this.openRemoveGroupDialogOperation
      //     }
      //   ]
      // })
      // if (this.hasInviteORQuestionPermission) {
      //   list.push({
      //     label: this.$t(`${this.i18nPrefix}.btn.action.inviteAnswerORQuestion`),
      //     operator: this.handleInviteAnswerORQuestionOperation
      //   })
      // }
      // list.push({
      //   label: this.$t(`${this.i18nPrefix}.btn.action.talentExport`),
      //   childrenMenuList: [
      //     {
      //       label: this.$t(`${this.i18nPrefix}.btn.action.exportAllCandidateInfo`),
      //       operator: this.handleExportCandidateAllInfoOperation
      //     },
      //     {
      //       label: this.$t('admin.application.candidate.btn.resume'),
      //       operator: this.handleExportResumeOperation
      //     },
      //     {
      //       label: this.$t('admin.application.candidate.btn.report'),
      //       operator: this.handleExportReportOperation
      //     },
      //     {
      //       label: this.$t('admin.application.candidate.btn.resumeAndReport'),
      //       operator: this.handleExportResumeAndReportOperation
      //     },
      //     {
      //       hidden: !this.hasExportConsentPermission,
      //       label: this.$t('admin.application.candidate.btn.exportConsentInfo'),
      //       operator: this.handleExportConsentInfoOperation
      //     }
      //   ]
      // })
      // if (this.hasAssessmentPermission) {
      //   list.push(
      //     {
      //       key: ASSESSMENT_INVITE_TYPE.PERSONALITY,
      //       label: this.$t(`${this.i18nPrefix}.btn.action.inviteValueAndStrengthLabel`),
      //       operator: this.handleInvitePersonalityOperation
      //     },
      //     {
      //       key: ASSESSMENT_INVITE_TYPE.PROBLEM_SOLVING,
      //       label: this.$t(`${this.i18nPrefix}.btn.action.inviteProblemSolveLabel`),
      //       operator: this.handleInviteProblemSolveOperation
      //     }
      //   )
      // }
      return list
    },
    filterList () {
      const vm = this
      const list = {
        [FILTER_GROUP_TYPE.ASSESSMENT_FIT]: {
          title: this.$t(`${this.i18nPrefix}.title.assessmentFit`),
          hidden: !this.hasAssessmentPermission || !this.hasAssessmentValueRequired,
          filterList: {
            assessment: {
              elType: AssessmentFitChart,
              multiple: true,
              props: {
                jobId: this.jobId
              },
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey) => {
                  const assessmentFit = []
                  _.forEach(SQUARED_UP_MAP, (fit, key) => {
                    if (_.some(value, item => item.id === key)) {
                      assessmentFit.push({
                        personalityFit: fit.personalityFit,
                        cultureFit: fit.cultureFit
                      })
                    }
                  })
                  return _.map(assessmentFit, item => {
                    const { cultureFit, personalityFit } = item
                    const summary = `${this.$t(`${this.i18nPrefix}.label.cultureFit`)}: ${cultureFit[0] * 10} ~ ${cultureFit[1] * 10}
                    ${this.$t(`${this.i18nPrefix}.label.personalityFit`)}: ${personalityFit[0] * 10} ~ ${personalityFit[1] * 10}`
                    return {
                      valueKey: null,
                      value: item,
                      detail: `${group.title}: ${summary}`,
                      summary: `${summary}`
                    }
                  })
                }
              },
              setParam: (params, val) => {
                const assessmentFit = []
                _.forEach(SQUARED_UP_MAP, (fit, key) => {
                  if (_.some(val, item => item.id === key)) {
                    assessmentFit.push({
                      personalityFit: fit.personalityFit,
                      cultureFit: fit.cultureFit
                    })
                  }
                })
                params.assessment_fit = _.map(assessmentFit, item => `${item.personalityFit[0]}~${item.personalityFit[1]}_${item.cultureFit[0]}~${item.cultureFit[1]}`).join(',')
              },
              cancelSelected: (filterValue, value) => {
                filterValue.splice(_.findIndex(filterValue, { id: value.id }), 1)
                return filterValue
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.PROBLEM_SOLVING_FIT]: {
          title: this.$t(`${this.i18nPrefix}.title.problemSolvingFit`),
          hidden: !this.hasAssessmentPermission || !this.hasProblemSolvingRequired,
          filterList: {
            problemSolving: {
              elType: ProblemSolvingFitChart,
              multiple: true,
              props: {
                jobId: this.jobId
              },
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey) => {
                  return _.chain(value).filter(item => item.selected).map(item => {
                    const fitRange = PROBLEM_SOLVING_FIT_RANGE_BAR[item.name]
                    const range = fitRange ? `${fitRange[0] === -1 ? 0 : fitRange[0] * 100} ~ ${fitRange[1] === 1.1 ? 100 : fitRange[1] * 100}` : ''
                    const summary = `${this.$t(`${this.i18nPrefix}.label.problemSolvingFilter.${item.name}`)} ${range}`
                    return {
                      valueKey: null,
                      value: item,
                      detail: `${group.title}: ${summary}`,
                      summary: `${summary}`
                    }
                  }).value()
                }
              },
              setParam: (params, val) => {
                params.problem_solving_fit = _.chain(val).filter(item => item.selected).map(item => item.name).join(',').value()
              },
              cancelSelected: (filterValue, value) => {
                value.selected = false
                const index = _.findIndex(filterValue, { id: value.id })
                if (index > -1) {
                  this.$set(filterValue, index, { ...value })
                }
                return filterValue
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.APPLICATION_DETAIL]: {
          title: this.$t(`${this.i18nPrefix}.title.applicationDetail`),
          filterList: {
            readStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.readStatus`),
              optionValue: 'value',
              optionList: [
                {
                  label: this.$t(`${this.i18nPrefix}.READ_STATUS.READ`),
                  value: READ_STATUS.READ
                },
                {
                  label: this.$t(`${this.i18nPrefix}.READ_STATUS.UNREAD`),
                  value: READ_STATUS.UNREAD
                }
              ],
              setParam: (params, val) => {
                params.is_viewed = val?.value
              }
            }
            // group: {
            //   elType: GroupSelect,
            //   label: this.$t(`${this.i18nPrefix}.label.group`),
            //   props: {
            //     loadData: this.loadGroupList
            //   },
            //   events: {
            //     saveEditGroup: this.handleSaveEditGroup,
            //     deleteGroup: this.handleDeleteGroup
            //   },
            //   optionValue: 'text',
            //   multiple: true,
            //   valueDisplay: {
            //     formatter: (value, filter, filterName, group, groupKey) => {
            //       if (!value || value.length < 1) {
            //         return
            //       }
            //       return _.map(value, (item, index) => {
            //         return {
            //           valueKey: index,
            //           value: item,
            //           detail: `${group.title} - ${filter.label}: ${item.text}`,
            //           summary: `${item.text}`
            //         }
            //       })
            //     }
            //   },
            //   cancelSelected: (filterValue, value) => {
            //     filterValue = _.filter(filterValue, item => item.id !== value.id)
            //     return filterValue
            //   },
            //   setParam: (params, val) => {
            //     const groups = []
            //     _.forEach(val, group => {
            //       groups.push(group.id)
            //     })
            //     params.group_ids = groups.join(',')
            //   }
            // },
          }
        },
        [FILTER_GROUP_TYPE.EMPLOYER]: {
          title: this.$t(`${this.i18nPrefix}.title.employer`),
          filterList: {
            workCompanyName: {
              elType: WorkCompanyName,
              label: null,
              multiple: true,
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey) => {
                  if (!value) {
                    return
                  }
                  const nameList = _.isArray(value.name) ? value.name : [value.name]
                  return _.map(nameList, name => ({
                    valueKey: name,
                    value: name,
                    detail: `${group.title} - ${this.$t(`${this.i18nPrefix}.label.workCompanyName`)}: ${name}`,
                    summary: `${this.$t(`${this.i18nPrefix}.label.workCompanyName`)}: ${name}`
                  }))
                }
              },
              cancelSelected: (filterValue, value) => {
                filterValue.name = null
                filterValue.isLastWork = true
                return filterValue
              },
              setParam: (params, val) => {
                const name = _.isArray(val.name) ? _.join(val.name, ';') : val.name
                if (val.isLastWork) {
                  params.last_work_company_name = name
                } else {
                  params.work_company_name = name
                }
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.JOB_TITLE]: {
          title: this.$t(`${this.i18nPrefix}.title.jobTitle`),
          filterList: {
            lastWorkJobName: {
              elType: 'el-input',
              label: this.$t(`${this.i18nPrefix}.label.lastWorkJobName`),
              setParam: (params, val) => {
                params.last_work_job_name = val
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.SKILL]: {
          title: this.$t(`${this.i18nPrefix}.title.skill`),
          filterList: {
            language: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.language`),
              loader: this.loadLanguageList,
              optionLabel: 'i18nName',
              optionValue: 'id',
              optionSearch: true,
              multiple: true,
              setParam: (params, val) => {
                params.language = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.EDUCATION]: {
          title: this.$t(`${this.i18nPrefix}.title.education`),
          filterList: {
            maxDegree: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.maxDegree`),
              optionList: _.map(DEGREE, (val, key) => createI18nProperty({ id: val }, 'i18nName', `meta.DEGREE.${key}`)),
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.max_degree = _.map(val, 'id').join(',')
              }
            },
            school: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.school`),
              loader: this.initSchoolList,
              multiple: true,
              optionValue: 'id',
              optionLabel: 'i18nName',
              optionSearch: this.loadSchoolList,
              optionTooltip: true,
              loadMore: (filter) => {
                this.loadMoreData(this.school, filter)
              },
              props: {
                popperClass: 'school-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.school)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible) {
                    if (filter) {
                      filter.option.data = []
                    }
                  }
                }
              },
              setParam: (params, val) => {
                params.school_id = _.map(val, 'id').join(',')
              }
            },
            major: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.major`),
              loader: this.initMajorList,
              multiple: true,
              optionValue: 'id',
              optionLabel: 'i18nName',
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.major, keywords, loadData, valueList)
              },
              loadMore: (filter) => {
                this.loadMoreData(this.major, filter)
              },
              props: {
                popperClass: 'major-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.major)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = []
                  }
                }
              },
              setParam: (params, val) => {
                params.major_ids = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.PROFILE_DETAIL]: {
          title: this.$t(`${this.i18nPrefix}.title.profileDetail`),
          filterList: {
            workYear: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.workYear`),
              multiple: true,
              optionSearch: true,
              props: {
                clearable: true,
                optionList: _.chain(0).range(16).map(year => {
                  return {
                    label: year >= 15 ? '15+' : year,
                    value: year
                  }
                }).value()
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.work_year_min = val[0]
                params.work_year_max = val[1]
              }
            },
            gender: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.gender`),
              multiple: true,
              optionValue: 'value',
              optionList: _.map(GENDER, (val, key) => {
                return {
                  label: this.$t(`${this.i18nPrefix}.gender.${key}`),
                  value: val
                }
              }),
              setParam: (params, val) => {
                params.gender = _.map(val, 'value').join(',')
              }
            },
            age: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.age`),
              multiple: true,
              props: {
                clearable: true,
                optionList: _.chain(18).range(100).map(age => {
                  return {
                    label: age >= 100 ? '100+' : age,
                    value: age
                  }
                }).value()
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.age_min = val[0]
                params.age_max = val[1]
              }
            },
            location: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.location`),
              optionLabel: 'locationName',
              optionValue: 'id',
              multiple: true,
              optionSearch: this.loadLocationList,
              loadTemplate: this.loadLocationTemplate,
              loader: this.getLocationList,
              loadMore: (filter) => {
                this.loadMoreData(this.location, filter)
              },
              props: {
                popperClass: 'location-dropdown',
                get noDataText () {
                  return vm.getNoDataText(vm.location)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible) {
                    if (filter) {
                      filter.option.data = []
                    }
                  }
                }
              },
              setParam: (params, val) => {
                const group = _.groupBy(val, 'type_code')
                // 处理直辖市
                const municipalityCityIds = []
                _.forEach(group.district, location => {
                  const cityName = _.findKey(MUNICIPALITY_PROVINCE, city => city === location.id)
                  if (cityName) {
                    municipalityCityIds.push(MUNICIPALITY_CITY[cityName])
                  }
                })

                params.location_country_id = _.map(group.country, 'id').join(',')
                params.location_province_id = _.map(group.district, 'id').join(',')
                params.location_city_id = [..._.map(group.city, 'id'), ...municipalityCityIds].join(',')
              }
            },
            appliedDate: {
              elType: DateRage,
              label: this.$t(`${this.i18nPrefix}.label.appliedDate`),
              multiple: true, // layout组件需要的值
              props: {
                align: 'center',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                disabledFutureDate: true
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.apply_start_time = val[0]
                if (val[1]) {
                  params.apply_end_time = moment(val[1]).add(1, 'days').format('YYYY-MM-DD')
                }
              }
            },
            consentStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.consentStatus`),
              multiple: true,
              hidden: !this.hasCompanyPolicy,
              optionList: this.companyPolicyList,
              optionLabel: 'i18nName',
              optionValue: 'value',
              optionSearch: true,
              optionTooltip: true,
              optionGroup: {
                labelKey: 'i18nName',
                valueKey: 'value',
                dataKey: 'status_list'
              },
              props: {
                popperClass: 'consent-info-popper'
              },
              valueDisplay: {
                formatter: this.formatConsentFilterDisplayValue
              },
              cancelSelected: (filterValue, value) => {
                filterValue = _.filter(filterValue, item => item.value !== value)
                return filterValue
              },
              setParam: (params, val) => {
                const option = []
                _.forEach(val, policy => {
                  option.push(policy.value)
                })
                params.consent_status = option.join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.CANDIDATE_PREFERENCE]: {
          title: this.$t(`${this.i18nPrefix}.title.candidatePreferences`),
          filterList: {
            applicationQuestionnaire: {
              elType: 'el-select',
              hidden: !this.hasPreferenceSurveyManagementPremium,
              label: this.$t(`${this.i18nPrefix}.label.applicantQuestionnaire`),
              loader: this.loadApplicationQuestionnaire,
              multiple: true,
              optionSearch: true,
              optionLabel: 'description',
              optionValue: 'id',
              optionGroup: {
                labelKey: 'title',
                dataKey: 'options'
              },
              setParam: (params, val) => {
                params.application_survey_answer_ids = _.map(val, 'id').join(',')
              }
            }
          }
        }
      }
      return _.filter(list, item => !item.hidden)
    },
    candidateListLength () {
      return this.candidateList.length
    },
    selectAllIsIndeterminate () {
      if (this.currentSelectedCount && (this.currentSelectedCount !== this.candidateTotalCount)) {
        return true
      }
      return false
    }
  },
  created () {
    this.pageDataLoader = this.initPageData()
  },
  mounted () {
    this.pageDataLoader.finally(() => {
      this.$eventBus.$emit('showLoading', false)
    }).then(() => {
      const candidateStatus = this.$route.query.candidate_status
      const readStatus = this.$route.query.read_status
      if (!candidateStatus && !readStatus) {
        return
      }
      this.listLoading = true
      const key = FILTER_GROUP_TYPE.APPLICATION_DETAIL
      const search = {
        [key]: {
          candidateStatus,
          readStatus
        }
      }
      return this.$refs.filterList.resetSearch({ search }, true)
    }).then((search) => {
      if (this.$refs.filterList) {
        this.$refs.filterList.noTriggerSearch = false
      }
      return this.handelSearch(search)
    }).finally(() => {
      this.listLoading = false
    })
  },
  methods: {
    ...mapActions('worldLocation', ['getWorldLocationList']),
    ...mapActions('agency', ['getAgencyJobApplicationList', 'getAgencyJobInfo']),
    ...mapActions('application', [
      'getLanguageList',
      'getSchoolList',
      'getMajorList',
      'getRecruiterQuestionnaire',
      'getApplicationQuestionnaire',
      'getPrescreenQuestionnaire',
      'getGroupList',
      'createGroup',
      'saveCandidateGroup',
      'updateGroup',
      'deleteGroup',
      'moveCandidateGroup',
      'removeCandidateFromGroup',
      'getExportJobApplicationExcelFieldInfo',
      'createExportJobApplicationExcelInfoTask',
      'exportCandidateProfilePdf',
      'getExportCandidateProfilePdfTaskStatus',
      'getExportConsentPDFaskStatus',
      'exportConsentPDF',
      'sendInviteAnswerOriginCompanyQuestion',
      'getCandidateStatusGroupList',
      'sendInviteNotification'
    ]),
    ...mapActions('account', [
      'getAccountPageConfigList',
      'createAccountPageConfig',
      'updateAccountPageConfig',
      'deleteAccountPageConfig'
    ]),
    ...mapActions('survey', ['getCompanySurveyQuestionList']),
    ...mapActions('job', ['getJobInfo']),
    ...mapActions('agreement', ['getCompanyPolicyItemList']),
    getStatusInfo (status) {
      return _.find(this.job.statusCountGroup, ['name', status])
    },
    formatRangeFilterDisplayValue (value, filter, filterName, group, groupKey) {
      const displayValue = {
        valueKey: -1,
        value: null,
        summary: null,
        get detail () {
          return `${group.title} - ${this.summary}`
        }
      }
      const startVal = value[0]
      const endVal = value[1]
      const nilVal = [null, undefined, '']
      if (!nilVal.includes(startVal) && !nilVal.includes(endVal)) {
        displayValue.valueKey = -1
        displayValue.value = value
        displayValue.summary = `${filter.label}: ${startVal} ~ ${endVal}`
      } else if (!nilVal.includes(startVal)) {
        displayValue.valueKey = 0
        displayValue.value = value
        displayValue.summary = `${filter.label}: > ${startVal}`
      } else if (!nilVal.includes(endVal)) {
        displayValue.valueKey = 1
        displayValue.value = value
        displayValue.summary = `${filter.label}: < ${endVal}`
      }
      return displayValue
    },
    cancelRangeFilterValue (filterValue, value, valueKey) {
      if (valueKey < 0) {
        return []
      } else {
        return _.map(filterValue, (val, index) => valueKey === index ? null : val)
      }
    },
    handleSelectedChange (val) {
      this.selectedCandidateList = val
      const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
      if (val.length !== this.candidateList.length) {
        this.isSelectedAllCandidate = false
        this.isSelectedAllCardCandidate = false
        this.isClickSelectAll = false
      }
      if (this.isSelectedAllCandidate && this.isSelectedAllCardCandidate) {
        this.currentSelectedCount = this.candidateTotalCount - hiddenCandidateList.length
      } else if (this.isSelectedAllCandidate || this.isSelectedAllCardCandidate) {
        this.cancelSelectedCandidateList = []
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(val, candidate)) {
            this.cancelSelectedCandidateList.push(candidate)
          }
        })
        const cancelCandidateIds = _.map(this.cancelSelectedCandidateList, candidate => candidate.candidate.id)
        this.searchParams.cancel_candidate_ids = cancelCandidateIds.join(',')
        const cancelSelectCount = this.candidateList.length - val.length
        this.currentSelectedCount = this.candidateList.length - cancelSelectCount
      } else if (this.isClickSelectAll) {
        const cancelSelectCount = this.candidateList.length - val.length
        this.currentSelectedCount = this.candidateTotalCount - cancelSelectCount
        this.cancelSelectedCandidateList = []
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(val, candidate)) {
            this.cancelSelectedCandidateList.push(candidate)
          }
        })
        const cancelCandidateIds = _.map(this.cancelSelectedCandidateList, candidate => candidate.candidate.id)
        this.searchParams.cancel_candidate_ids = cancelCandidateIds.join(',')
      } else {
        this.currentSelectedCount = val.length
      }
    },
    handleSelectAllCard (selected) {
      if (selected) {
        const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
        _.forEach(this.candidateList, candidate => {
          if (!candidate.is_agency_uploaded_and_hid) {
            candidate.selected = true
          }
        })
        this.isSelectedAllCandidate = true
        this.isSelectedAllCardCandidate = true
        this.currentSelectedCount = this.candidateTotalCount - hiddenCandidateList.length
        this.isClickSelectAll = true
      } else {
        _.forEach(this.candidateList, candidate => {
          candidate.selected = false
        })
        this.isSelectedAllCandidate = false
        this.isSelectedAllCardCandidate = false
        this.currentSelectedCount = 0
        this.isClickSelectAll = false
      }
    },
    handleSelectAll (selected) {
      const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
      this.isSelectedAllCandidate = selected.length > 0
      this.isClickSelectAll = selected.length > 0
      this.currentSelectedCount = this.isSelectedAllCandidate ? this.candidateTotalCount - hiddenCandidateList.length : 0
    },
    handleUploadCandidateAction () {
      const back = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-agency/application/job/${this.jobId}/add?back=${back}`)
    },
    hasSelected () {
      if (!this.isSelectedAllCandidate && this.selectedCandidateList.length < 1) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAtLeastCandidate`))
        return false
      }
      return true
    },
    handleChangeStatusAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.changeCandidateStatusDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.changeCandidateStatusDialog.showDialog()
    },
    handleChangeStatusSuccess () {
      this.loadJobInfo()
    },
    handleCopyCandidateAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.copyCandidateDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.copyCandidateDialog.showDialog()
    },
    handleInviteHMRatingAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.ratingDialog = {
        applicationList: this.selectedCandidateList,
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      }
      this.$refs.inviteHmRatingDialog.showDialog()
    },
    handleSentHmRatingInvite (inviteResult) {
      const changedCandidateIds = inviteResult.changed_candidate_ids
      const applicationList = this.ratingDialog.applicationList
      _.forEach(applicationList, application => {
        if (changedCandidateIds.includes(application.candidate.id)) {
          application.status = addI18nProperty(inviteResult.candidate_status, 'i18nName', 'name_cn', 'name_en')
        }
      })
    },
    handleInviteInterviewAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.interviewDialog = {
        applicationList: this.selectedCandidateList,
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      }
      this.$refs.inviteInterviewDialog.showDialog()
    },
    handleInviteQuestionAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.questionDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.inviteQuestionDialog.openDialog()
    },
    handleContactAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.contactDialog = {
        isSelectAll: this.isSelectedAllCandidate,
        candidateIds: _.map(this.selectedCandidateList, item => item.candidate.id)
      }
      this.$refs.contactDialog.openDialog()
    },
    handleInviteOnboardingAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.onboardingDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.inviteOnboardingDialog.openDialog()
    },
    handleInviteSatisfactionAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.satisfactionDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.inviteSatisfactionDialog.openDialog()
    },
    handleInvitePortalAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.portalDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.invitePortalDialog.openDialog()
    },
    openAddGroupDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > 60000 || (this.isSelectedAllCandidate && this.candidateTotalCount > 60000)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.groupCandidateLimit`))
        return
      }
      this.loadGroupList()
      this.$refs.addGroupDialog.openDialog()
    },
    async handleInviteAnswerORQuestionAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const params = {
        candidate_ids: _.map(this.selectedCandidateList, item => item.candidate.id),
        job_id: this.jobId,
        is_all_application: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        search_params: this.searchParams
      }
      const resp = await this.sendInviteAnswerOriginCompanyQuestion(params)
      if (resp) {
        const successCount = resp.send_success_count
        this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteORQuestion`, { inviteCount: this.selectedCandidateList.length, successCount: successCount }))
      }
    },
    openMoveGroupDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > 60000 || (this.isSelectedAllCandidate && this.candidateTotalCount > 60000)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.groupCandidateLimit`))
        return
      }
      this.loadGroupList()
      this.$refs.moveGroupDialog.openDialog()
    },
    openRemoveGroupDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > 60000 || (this.isSelectedAllCandidate && this.candidateTotalCount > 60000)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.groupCandidateLimit`))
        return
      }
      this.loadGroupList()
      this.$refs.removedGroupDialog.openDialog()
    },
    handleSentInterviewInvite (inviteResult) {
      const changedCandidateIds = inviteResult.changed_candidate_ids
      const applicationList = this.interviewDialog.applicationList
      _.forEach(applicationList, application => {
        if (changedCandidateIds.includes(application.candidate.id)) {
          application.status = addI18nProperty(inviteResult.candidate_status, 'i18nName', 'name_cn', 'name_en')
        }
      })
    },
    handleInvitePersonalityAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidateIds = _.map(this.selectedCandidateList, item => item.candidate.id)
      const isSelectAll = this.isSelectedAllCandidate
      const typeId = ASSESSMENT_INVITE_TYPE.PERSONALITY
      this.sendInviteAssessment(typeId, candidateIds, isSelectAll)
    },
    handleInviteProblemSolveAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidateIds = _.map(this.selectedCandidateList, item => item.candidate.id)
      const isSelectAll = this.isSelectedAllCandidate
      const typeId = ASSESSMENT_INVITE_TYPE.PROBLEM_SOLVING
      this.sendInviteAssessment(typeId, candidateIds, isSelectAll)
    },
    handleInvitePersonalityOperation (rowData) {
      const candidateIds = [rowData.candidate.id]
      const typeId = ASSESSMENT_INVITE_TYPE.PERSONALITY
      this.sendInviteAssessment(typeId, candidateIds)
    },
    handleInviteProblemSolveOperation (rowData) {
      const candidateIds = [rowData.candidate.id]
      const typeId = ASSESSMENT_INVITE_TYPE.PROBLEM_SOLVING
      this.sendInviteAssessment(typeId, candidateIds)
    },
    handleAddCommentOperation (rowData) {
      this.commentDialog = {
        isSelectAll: this.isSelectedAllCandidate,
        candidateId: rowData.candidate.id
      }
      this.$refs.addCommentDialog.openDialog()
    },
    handleLastedWorkChange () {
      const params = this.parseSearchToParams(this.search)
      if (params.work_company_name || params.last_work_company_name) {
        this.handelSearch()
      }
    },
    async sendInviteAssessment (typeId, candidateIds, isSelectAll) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.sendInviteNotification({
          type_id: typeId,
          job_id: this.jobId,
          candidate_ids: candidateIds,
          is_all_application: isSelectAll,
          params: this.searchParams
        })
        if (resp) {
          if (candidateIds.length > 1 || isSelectAll) { // 多选或全选
            const candidateCount = isSelectAll ? this.candidateTotalCount : candidateIds.length
            const successCount = resp.success?.length
            const noEmailCount = resp.no_email_count?.length
            const completedCount = resp.ignore?.length
            this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteFinishAssessment.batchInvite`, {
              candidateCount,
              successCount,
              noEmailCount,
              completedCount
            }))
          } else if (resp.success && resp.success.length > 0) {
            this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteFinishAssessment.success`))
          } else if (resp.no_email_count && resp.no_email_count.length > 0) {
            this.$message.warning(this.$t(`${this.i18nPrefix}.message.inviteFinishAssessment.noEmailAccount`))
          } else if (resp.ignore && resp.ignore.length > 0) {
            this.$message.warning(this.$t(`${this.i18nPrefix}.message.inviteFinishAssessment.hasFinished`))
          } else {
            this.$message.error(this.$t(`${this.i18nPrefix}.message.inviteFinishAssessment.fail`))
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleAddTagDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      this.addTagDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidateList: candidates
      }
      if (candidates.length > SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG }))
        return
      }
      this.$refs.addTagDialog.showDialog()
    },
    handleAddTagOperation (rowData) {
      this.addTagDialog = {
        isSelectAll: false,
        candidateList: [rowData.candidate.id]
      }
      this.$refs.addTagDialog.showDialog()
    },
    // handleChangeStatusOperation (rowData, status) {
    //   this.changeCandidateStatusDialog = {
    //     isSelectAll: false,
    //     applicationList: [rowData]
    //   }

    //   if (status) {
    //     this.changeCandidateStatusDialog.defaultStatusKey = status
    //   } else {
    //     this.changeCandidateStatusDialog.defaultStatusKey = rowData.status.key
    //   }
    //   this.$refs.changeCandidateStatusDialog.showDialog()
    // },
    handleCopyCandidateOperation (rowData) {
      this.copyCandidateDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.copyCandidateDialog.showDialog()
    },
    handleContactOperation (rowData) {
      this.contactDialog = {
        isSelectAll: false,
        candidateIds: [rowData.candidate.id]
      }
      this.$refs.contactDialog.openDialog()
    },
    handleInviteHMRatingOperation (rowData) {
      this.ratingDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteHmRatingDialog.showDialog()
    },
    handleInviteInterviewOperation (rowData) {
      this.interviewDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteInterviewDialog.showDialog()
    },
    handleInviteQuestionOperation (rowData) {
      this.questionDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteQuestionDialog.openDialog()
    },
    handleInviteOnboardingOperation (rowData) {
      this.onboardingDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteOnboardingDialog.openDialog()
    },
    handleInviteSatisfactionOperation (rowData) {
      this.satisfactionDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteSatisfactionDialog.openDialog()
    },
    handleInvitePortalOperation (rowData) {
      this.portalDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.invitePortalDialog.openDialog()
    },
    openAddGroupDialogOperation (rowData) {
      this.addCandidateGroupDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadGroupList()
      this.$refs.addGroupDialog.openDialog()
    },
    async handleInviteAnswerORQuestionOperation (rowData) {
      const params = {
        candidate_ids: [rowData.candidate.id],
        job_id: this.jobId
      }
      const resp = await this.sendInviteAnswerOriginCompanyQuestion(params)
      if (resp) {
        const successCount = resp.send_success_count
        this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteORQuestion`, { inviteCount: 1, successCount: successCount }))
      }
    },
    async handleSaveOperatorCandidateToGroup (groupInfo, callback) {
      const currentGroup = groupInfo.currentGroup
      const talentPoolGroup = groupInfo.talentPoolGroup
      let resp = null
      try {
        resp = await this.saveCandidateGroup({
          candidate_ids: this.addCandidateGroupDialog.candidateList,
          job_id: this.jobId,
          group_list: currentGroup && [currentGroup],
          talent_pool_group: talentPoolGroup,
          remove_bound_group: false,
          select_all_candidate: false,
          search_params: this.searchParams
        })
        if (resp) {
          this.$message.success(this.$t('common.message.saveSuccess'))
        } else {
          this.$message.success(this.$t('common.message.saveFail'))
        }
      } finally {
        this.loadGroupList()
        callback(resp)
      }
    },
    openMoveGroupDialogOperation (rowData) {
      this.moveCandidateGroupDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadGroupList()
      this.$refs.moveGroupDialog.openDialog()
    },
    async handleSaveOperatorMovedGroup (groupInfo, callback) {
      let resp = null
      try {
        resp = await this.moveCandidateGroup({
          candidate_ids: this.moveCandidateGroupDialog.candidateList,
          from_group_id: groupInfo.from,
          to_group: groupInfo.to,
          comment: groupInfo.comment,
          remove_bound_group: false,
          select_all_candidate: false,
          search_params: this.searchParams
        })
        this.loadGroupList()
      } finally {
        callback(resp)
      }
    },
    openRemoveGroupDialogOperation (rowData) {
      this.removeCandidateGroupDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadGroupList()
      this.$refs.removedGroupDialog.openDialog()
    },
    async handleSaveOperatorRemovedGroup (groupInfo, callback) {
      const groupId = groupInfo.from
      const comment = groupInfo.comment
      let resp = null
      try {
        resp = await this.removeCandidateFromGroup({
          candidate_list: this.removeCandidateGroupDialog.candidateList,
          group_id: groupId,
          comment: comment,
          select_all_candidate: false,
          search_params: this.searchParams
        })
        this.loadGroupList()
      } finally {
        callback(resp)
      }
    },

    // handleExportCandidateAllInfoOperation (rowData) {
    //   this.exportCandidateAllInfoDialog = {
    //     isSelectAll: false,
    //     isOperator: true,
    //     candidateList: [rowData.candidate.id]
    //   }
    //   this.loadExportJobApplicationExcelFields()
    //   this.$refs.exportCandidateAllInfoDialog.showDialog()
    // },
    async handleSaveOperatorExportCandidateAllInfo (optionInfo, callback) {
      const params = {
        field_list: optionInfo,
        select_all_candidate: false,
        candidate_ids: this.exportCandidateAllInfoDialog.candidateList,
        search_params: this.searchParams,
        job_id: this.jobId,
        export_from_job_applicant_list: true
      }
      let resp = null
      try {
        resp = await this.createExportJobApplicationExcelInfoTask(params)
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
          showClose: true,
          duration: 10 * 1000 // 10s
        })
      } finally {
        callback(resp)
      }
    },
    handleExportResumeOperation (rowData) {
      const candidateName = rowData.candidate.name
      const candidateId = rowData.candidate.id
      const date = moment().format('YYYY-MM-DD')
      const companyName = getI18nPropertyValue(rowData.job.company, 'cn_name', 'name')
      const jobName = getI18nPropertyValue(rowData.job, 'cn_title', 'title')
      const downloadFileName = `${companyName}_${jobName}_${candidateName}_${candidateId}_${date}.pdf`
      this.exportSignalPDF(rowData.candidate.id, true, '0', downloadFileName)
    },
    handleExportReportOperation (rowData) {
      this.exportSignalPDF(rowData.candidate.id, false, '1')
    },
    handleExportResumeAndReportOperation (rowData) {
      this.exportSignalPDF(rowData.candidate.id, true, '1')
    },
    async exportSignalPDF (candidateId, showBaseInfo, profileType, downloadFileName) {
      const exportPdfStatus = this.exportPdfStatus
      if (exportPdfStatus.loading) {
        return
      }
      exportPdfStatus.loading = true
      exportPdfStatus.finished = false
      exportPdfStatus.task = new AsyncTask(() => this.exportCandidateProfilePdf({
        candidate_ids: [candidateId],
        show_base_info: showBaseInfo,
        profile_type: profileType,
        select_all_candidate: false,
        search_params: this.searchParams,
        job_id: this.jobId
      }), (taskId) => this.getExportCandidateProfilePdfTaskStatus({
        task_id: taskId
      }), (taskId) => {
        let downloadUrl = `/django_rest/company/job/application/export/profile/?task_id=${taskId}&download=1`
        if (downloadFileName) {
          downloadUrl += `&file_name=${window.encodeURIComponent(downloadFileName)}`
        }
        window.location.href = this.$DjangoBaseUrl(downloadUrl)
        exportPdfStatus.loading = false
        exportPdfStatus.finished = false
        exportPdfStatus.task = null
      })
    },
    handleExportConsentInfoOperation (rowData) {
      this.exportConsentInfoPDF([rowData])
    },
    async getLocationList () {
      if (this.location.hasLoad) {
        return
      }
      this.location.hasLoad = true
      const resp = await this.getWorldLocationList()
      if (!resp) {
        return
      }
      this.location.data = _.map(resp, location => {
        addI18nProperty(location, 'i18nName', 'cn_name', 'name')
        location.searchTextList = []
        location.searchTextList.push(location.name, location.cn_name, location.pinyin_name)
        if (location.parent_id) {
          const locationInfo = _.find(resp, item => item.id === location.parent_id)
          location.parent = locationInfo
          location.searchTextList.push(locationInfo.name, locationInfo.cn_name, locationInfo.pinyin_name)
        }
        // 处理四个直辖市, 不出现在下拉列表中
        if (_.findKey(MUNICIPALITY_CITY, city => city === location.id)) {
          location.searchTextList = null
        }
        if (location.type_code === 'region') {
          location.searchTextList = null
        }
        const nameList = []
        if (location.parent) {
          this.getParentLocation(location, nameList)
        }
        location.locationName = _.chain([location.i18nName, ...nameList]).filter().join(' - ').value()
        return location
      })
      return this.location.data
    },
    async loadLocationList (keywords, loadData, valueList) {
      this.location.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(this.location.data, location => {
        if (valueList?.length > 0) {
          return _.includes(valueList, location.id)
        } else {
          const keywordsList = _.map(location.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.location.page = 1
      this.location.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.location.pageSize)
    },
    getParentLocation (location, nameList) {
      const parent = location.parent
      if (parent) {
        if (parent.searchTextList) {
          nameList.push(parent.i18nName)
        }
        if (parent.parent_id) {
          this.getParentLocation(parent, nameList)
        }
      }
    },
    async loadLocationTemplate (valueList, filter, formattedFilterValues) {
      if (valueList?.length < 1) {
        return []
      }
      const locationList = await this.loadLocationList(null, null, valueList)
      if (locationList.length > 0) {
        filter.option.data = locationList
        formattedFilterValues.location = locationList
      }
    },
    async initSchoolList () {
      if (this.school.hasLoad) {
        return
      }
      this.school.hasLoad = true
      const resp = await this.getSchoolList()
      if (!resp) {
        return
      }
      this.school.data = _.map(resp.schools, school => {
        addI18nProperty(school, 'i18nName', 'cn_name', 'name')
        school.searchTextList = []
        school.searchTextList.push(school.name, school.cn_name, school.pinyin_name)
        return school
      })
      return this.school.data
    },
    async initMajorList () {
      if (this.major.hasLoad) {
        return
      }
      this.major.hasLoad = true
      const resp = await this.getMajorList()
      if (!resp) {
        return
      }
      this.major.data = _.map(resp.majors, major => {
        addI18nProperty(major, 'i18nName', 'cn_name', 'name')
        major.searchTextList = []
        major.searchTextList.push(major.name, major.cn_name)
        return major
      })
      return this.major.data
    },
    async loadLanguageList () {
      const resp = await this.getLanguageList()
      if (resp) {
        this.languageList = _.map(resp.languages, item => addI18nProperty(item, 'i18nName', 'cn_name', 'en_name'))
      }
      return this.languageList
    },
    async loadSchoolList (keywords, loadData, valueList) {
      this.school.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(this.school.data, school => {
        if (valueList?.length > 0) {
          return _.includes(valueList, school.id)
        } else {
          const keywordsList = _.map(school.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.school.page = 1
      this.school.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.school.pageSize)
    },
    async loadCompanyPolicyList () {
      const vm = this
      const params = {
        job_id: this.jobId
      }
      const resp = await this.getCompanyPolicyItemList(params)
      if (resp) {
        const sortedPolicy = _.orderBy(_.values(resp), ['created_time'], ['desc'])
        const policyList = []
        _.forEach(sortedPolicy, policy => {
          _.forEach(policy.policy_list, policyItem => {
            Object.defineProperty(policyItem, 'i18nName', {
              enumerable: true,
              configurable: true,
              get () {
                const createdTime = moment(policy.created_time).format('YYYY/MM/DD')
                const code = vm.$t(`${vm.i18nPrefix}.label.consentVersionCode`)
                const i18nContent = getI18nPropertyValue(this, 'content_cn', 'content_en')
                const i18nName = `${createdTime} ${code}: ${i18nContent}`
                return i18nName
              }
            })
            const optionList = _.map(CONSENT_STATUS, (val, key) => {
              const option = { value: `${policyItem.id}-${val}` }
              Object.defineProperty(option, 'i18nName', {
                enumerable: true,
                configurable: true,
                get () {
                  return vm.$t(`${vm.i18nPrefix}.consentStatus.${key}`)
                }
              })
              return option
            })
            policyItem.status_list = optionList
            policyList.push(policyItem)
          })
        })
        this.companyPolicyList = policyList
        return this.companyPolicyList
      }
    },
    formatConsentFilterDisplayValue (value, filter, filterName, group, groupKey) {
      const displayValueList = []
      _.forEach(value, option => {
        const displayValue = {
          valueKey: null,
          value: option.value,
          summary: null,
          detail: null
        }
        const optionValue = option.value + ''
        const policyItemId = parseInt(optionValue.split('-')[0])
        const policyItem = _.find(this.companyPolicyList, policy => policy.id === policyItemId)
        displayValue.summary = option.i18nName
        displayValue.detail = `${group.title}-${policyItem.i18nName}`
        displayValueList.push(displayValue)
      })
      return displayValueList
    },
    async loadGroupList () {
      const resp = await this.getGroupList({ job_id: this.jobId })
      if (resp) {
        this.groupList = resp.group_list
      }
      return this.groupList
    },
    // async loadRecruiterQuestionnaire () {
    //   const resp = await this.getRecruiterQuestionnaire({ jobId: this.jobId })
    //   if (resp) {
    //     this.recruiterQuestionnaire = _.filter(resp, item => HAS_OPTIONS_QUESTION_TYPES.includes(item.type))
    //   }
    //   return this.recruiterQuestionnaire
    // },
    async loadApplicationQuestionnaire () {
      const resp = await this.getApplicationQuestionnaire({ jobId: this.jobId })
      if (resp) {
        this.applicationQuestionnaire = _.filter(resp, item => HAS_OPTIONS_QUESTION_TYPES.includes(item.type))
      }
      return this.applicationQuestionnaire
    },
    // async loadPrescreenQuestionnaire () {
    //   const resp = await this.getPrescreenQuestionnaire({ jobId: this.jobId })
    //   if (resp) {
    //     this.prescreenQuestionnaire = _.filter(resp, item => HAS_OPTIONS_QUESTION_TYPES.includes(item.type))
    //   }
    //   return this.prescreenQuestionnaire
    // },
    // async loadCandidateSurveyQuestionList () {
    //   const resp = await this.getCompanySurveyQuestionList({ survey_type: 'candidate' })
    //   if (resp) {
    //     this.candidateSurveyQuestionList = _.map(resp, question => {
    //       addI18nProperty(question, 'i18nName', 'cn_name', 'name')
    //       question.answer = _.map(question.answer, answer => {
    //         addI18nProperty(answer, 'i18nName', 'cn_name', 'name')
    //         answer.questionId = question.id
    //         return answer
    //       })
    //       return question
    //     })
    //     return this.candidateSurveyQuestionList
    //   }
    // },
    // async loadEmployeeSurveyQuestionList () {
    //   const resp = await this.getCompanySurveyQuestionList({ survey_type: 'employee' })
    //   if (resp) {
    //     this.employeeSurveyQuestionList = _.map(resp, question => {
    //       addI18nProperty(question, 'i18nName', 'cn_name', 'name')
    //       question.answer = _.map(question.answer, answer => {
    //         addI18nProperty(answer, 'i18nName', 'cn_name', 'name')
    //         answer.questionId = question.id
    //         return answer
    //       })
    //       return question
    //     })
    //     return this.employeeSurveyQuestionList
    //   }
    // },
    async handleSaveEditGroup (groupInfo, callback) {
      const groupId = groupInfo.id
      let resp = null
      if (!groupId) {
        return
      }
      try {
        const params = {
          group_id: groupId,
          text: groupInfo.text
        }
        resp = await this.updateGroup(params)
      } finally {
        this.loadGroupList()
        callback(resp)
        const search = this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL]
        let filters = []
        if (search && search.group) {
          filters = search.group
          if (filters.length > 0) {
            _.forEach(filters, group => {
              if (group.id === groupId) {
                group.text = groupInfo.text
              }
            })
            this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL].group = filters
          }
        }
      }
    },
    async handleDeleteGroup (groupInfo) {
      const groupId = groupInfo.id
      if (!groupId) {
        return
      }
      const params = {
        group_id: groupId
      }
      const resp = await this.deleteGroup(params)
      if (resp) {
        this.loadGroupList()
        this.$message({
          message: this.$t(`${this.i18nPrefix}.message.deleteGroupSuccess`),
          type: 'success'
        })
        const search = this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL]
        let filters = []
        if (search && search.group) {
          filters = search.group
          if (filters.length > 0) {
            this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL].group = _.filter(filters, group => group.id !== groupId)
          }
        }
      }
    },
    async handleSaveMovedGroup (groupInfo, callback) {
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      let resp = null
      try {
        resp = await this.moveCandidateGroup({
          candidate_ids: candidates,
          from_group_id: groupInfo.from,
          to_group: groupInfo.to,
          comment: groupInfo.comment,
          remove_bound_group: false,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams
        })
        this.loadGroupList()
      } finally {
        callback(resp)
      }
    },
    async handleSaveRemovedGroup (groupInfo, callback) {
      const groupId = groupInfo.from
      const comment = groupInfo.comment
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      let resp = null
      try {
        resp = await this.removeCandidateFromGroup({
          candidate_list: candidates,
          group_id: groupId,
          comment: comment,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams
        })
        this.loadGroupList()
      } finally {
        callback(resp)
      }
    },
    handleSearchCandidateByGroup (groupInfo) {
      const search = this.$refs.filterList.search
      search[FILTER_GROUP_TYPE.APPLICATION_DETAIL].group = _.map(groupInfo, item => item.id)
      this.$refs.filterList.resetSearch({ search })
    },
    async saveAddedGroup (groupInfo, callback) {
      const currentGroup = groupInfo.currentGroup
      const talentPoolGroup = groupInfo.talentPoolGroup
      let resp = null
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      try {
        resp = await this.saveCandidateGroup({
          candidate_ids: candidates,
          job_id: this.jobId,
          group_list: currentGroup && [currentGroup],
          talent_pool_group: talentPoolGroup,
          remove_bound_group: false,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams
        })
        if (resp) {
          this.$message.success(this.$t('common.message.saveSuccess'))
        } else {
          this.$message.success(this.$t('common.message.saveFail'))
        }
      } finally {
        this.loadGroupList()
        callback(resp)
      }
    },
    // handleExportCandidateAllInfo () {
    //   const hasSelected = this.hasSelected()
    //   if (!hasSelected) {
    //     return
    //   }
    //   this.exportCandidateAllInfoDialog = {
    //     isSelectAll: this.isSelectedAllCandidate,
    //     candidateList: _.map(this.selectedCandidateList, item => item.candidate.id)
    //   }
    //   this.loadExportJobApplicationExcelFields()
    //   this.$refs.exportCandidateAllInfoDialog.showDialog()
    // },
    handleExportResume () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.exportPDF(true, '0')
    },
    handleExportReport () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.exportPDF(false, '1')
    },
    handleExportResumeAndReport () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.exportPDF(true, '1')
    },
    handleExportConsentInfo () {
      this.exportConsentInfoPDF()
    },
    async exportPDF (showBaseInfo, profileType) {
      const exportPdfStatus = this.exportPdfStatus
      if (exportPdfStatus.loading) {
        return
      }
      exportPdfStatus.loading = true
      exportPdfStatus.finished = false
      const exportCandidates = []
      _.forEach(this.selectedCandidateList, candidate => {
        exportCandidates.push(candidate.candidate.id)
      })
      if (exportCandidates.length === 1) {
        exportPdfStatus.task = new AsyncTask(() => this.exportCandidateProfilePdf({
          candidate_ids: exportCandidates,
          show_base_info: showBaseInfo,
          profile_type: profileType,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams,
          job_id: this.jobId
        }), (taskId) => this.getExportCandidateProfilePdfTaskStatus({
          task_id: taskId
        }), (taskId) => {
          window.location.href = this.$DjangoBaseUrl(`/django_rest/company/job/application/export/profile/?task_id=${taskId}&download=1`)
          exportPdfStatus.loading = false
          exportPdfStatus.finished = false
          exportPdfStatus.task = null
        })
      } else {
        const resp = await this.exportCandidateProfilePdf({
          candidate_ids: exportCandidates,
          show_base_info: showBaseInfo,
          profile_type: profileType,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams,
          job_id: this.jobId
        })
        if (resp) {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
            showClose: true,
            duration: 10 * 1000 // 10s
          })
          exportPdfStatus.loading = false
          exportPdfStatus.finished = false
          exportPdfStatus.task = null
        }
      }
    },
    async exportConsentInfoPDF (candidateList = this.selectedCandidateList) {
      const exportConsentStatus = this.exportConsentStatus
      if (exportConsentStatus.loading) {
        return
      }
      exportConsentStatus.loading = true
      exportConsentStatus.finished = false
      exportConsentStatus.task = new AsyncTask(() => this.exportConsentPDF({
        candidate_ids: _.map(candidateList, item => item.candidate.id),
        select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        search_params: this.searchParams,
        job_id: this.jobId
      }), (taskId) => this.getExportConsentPDFaskStatus({
        task_id: taskId
      }), (taskId) => {
        window.location.href = this.$DjangoBaseUrl(`/django_rest/company/job/application/export/consent/?task_id=${taskId}&download=1`)
        exportConsentStatus.loading = false
        exportConsentStatus.finished = false
        exportConsentStatus.task = null
      })
    },
    async saveExportCandidateAllInfo (optionInfo, callback) {
      const params = {
        field_list: optionInfo,
        select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidate_ids: _.map(this.selectedCandidateList, item => item.candidate.id),
        search_params: this.searchParams,
        job_id: this.jobId,
        export_from_job_applicant_list: true
      }
      let resp = null
      try {
        resp = await this.createExportJobApplicationExcelInfoTask(params)
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
          showClose: true,
          duration: 10 * 1000 // 10s
        })
      } finally {
        callback(resp)
      }
    },
    async loadSearchTemplateList () {
      const resp = await this.getAccountPageConfigList({ page_type: 'AGENCY_JOB_APPLICATION_LIST' })
      if (resp) {
        this.searchTemplateList = _.map(resp, pageConfig => {
          return {
            _config: pageConfig,
            id: pageConfig.id,
            name: pageConfig.config.name,
            search: pageConfig.config.search
          }
        })
      }
    },
    async loadJobInfo () {
      this.jobLoading = true
      try {
        const resp = await this.getAgencyJobInfo({ jobId: this.jobId })
        if (resp) {
          const job = resp
          addI18nProperty(job, 'jobName', 'cn_name', 'name')
          this.jobName = job.jobName
          this.hasProblemSolvingRequired = resp.problem_solving_required === '1'
          this.hasAssessmentValueRequired = resp.assessment_value_required === '1'
          this.hasPersonalityRequired = resp.personality_required === '1'
          this.isElcOriginCompany = resp.is_elc_origin_company
          this.hasAssessmentPremium = resp.has_assessment_premium
          this.hasAIResumeMatchPremium = resp.has_ai_resume_match_premium
          this.hasPreferenceSurveyManagementPremium = resp.has_preference_survey_management_premium
          this.job = job
        }
      } finally {
        this.jobLoading = false
      }
    },
    async loadStatusGroupList () {
      if (this.statusLoaded) {
        return this.statusList
      }
      const resp = await this.getCandidateStatusGroupList({
        job_id: this.jobId
      })
      if (resp) {
        const statusList = []
        const statusKeyList = []
        _.forEach(resp.status_list, status => {
          statusList.push(addI18nProperty(status, 'i18nName', 'name_cn', 'name_en'))
          statusKeyList.push(status.key)
        })
        this.statusGroupList = _.map(resp.group_list, group => {
          createI18nProperty(group, 'i18nName', `${this.i18nPrefix}.STATUS_GROUP.${group.name}`)
          _.forEach(group.status_list, status => {
            addI18nProperty(status, 'i18nName', 'name_cn', 'name_en')
            status.canChangeTo = statusKeyList.includes(status.key)
          })
          return group
        })
        this.statusList = statusList
        this.statusLoaded = true

        return this.statusList
      }
    },
    async searchItemList (item, keywords, loadData, valueList) {
      item.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(item.data, item => {
        if (valueList?.length > 0) {
          return _.includes(valueList, item.id)
        } else {
          const keywordsList = _.map(item.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      item.page = 1
      item.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, item.pageSize)
    },
    loadMoreData (item, filter) {
      if (item.currentData && item.page * item.pageSize > item.currentData.length) {
        return
      }
      const data = item.currentData.slice(item.page * item.pageSize, (item.page + 1) * item.pageSize)
      item.page += 1
      filter.option.data.push(...data)
    },
    // async loadExportJobApplicationExcelFields () {
    //   if (this.loading) {
    //     return
    //   }
    //   this.loading = true
    //   const resp = await this.getExportJobApplicationExcelFieldInfo()
    //   if (resp) {
    //     const parentGroupField = _.groupBy(resp, 'parent_field')
    //     const fieldList = []
    //     _.forEach(PARENT_FIELD_NAME_LIST, (value, key) => {
    //       const childrenFields = parentGroupField[key]
    //       _.forEach(childrenFields, field => {
    //         addI18nProperty(field, 'i18nName', 'cn_name', 'en_name')
    //       })
    //       let fieldNote = null
    //       if (childrenFields.length === 1) {
    //         const childrenField = childrenFields[0]
    //         fieldNote = {
    //           i18nName: this.$t(`${this.i18nPrefix}.PARENT_FIELD_NAME_LIST.${value}`),
    //           id: key,
    //           children: [],
    //           col_index: childrenField.col_index,
    //           data_type: childrenField.data_type,
    //           header_value: childrenField.i18nName
    //         }
    //       } else {
    //         fieldNote = {
    //           i18nName: this.$t(`${this.i18nPrefix}.PARENT_FIELD_NAME_LIST.${value}`),
    //           id: key,
    //           children: childrenFields
    //         }
    //       }
    //       if (fieldNote) {
    //         fieldList.push(fieldNote)
    //       }
    //     })
    //     this.exportInfo.data[0].children = fieldList
    //   }
    //   this.loading = false
    // },
    async handleCreateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.createAccountPageConfig({
          page_type: 'AGENCY_JOB_APPLICATION_LIST',
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleUpdateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.updateAccountPageConfig({
          id: template._config.id,
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleClearSearchTemplate () {
      this.searchTemplate = null
    },
    async handleDeleteSearchTemplate (searchTemplate, deletedTemplateIndex) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.deleteAccountPageConfig({
          id: searchTemplate.id
        })
        if (resp) {
          this.searchTemplateList.splice(deletedTemplateIndex, 1)
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.deleteSuccess`)
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    initPageData () {
      this.getLocationList()
      // this.loadStatusGroupList()
      return Promise.all([
        this.loadJobInfo(),
        this.loadSearchTemplateList(),
        this.loadCompanyPolicyList()
      ])
    },
    getNoDataText (info) {
      if (!info.data || info.data.length === 0) {
        return this.$t('el.select.noData')
      } else if (info.keywords && (!info.currentData || info.currentData.length === 0)) {
        return this.$t('el.select.noMatch')
      }
      return this.$t(`${this.i18nPrefix}.label.pleaseStartTyping`)
    },
    parseSearchToParams (search) {
      const params = { order: `${this.listOrder.order === '-' ? '-' : ''}${this.listOrder.prop}` }
      const filterList = this.filterList
      _.forEach(search, (group, groupKey) => {
        if (groupKey === 'keywords') {
          params.keywords = group
          return
        }
        if (groupKey === 'candidateName') {
          params.candidate_name = group
          return
        }
        if (groupKey === 'candidateId') {
          params.candidate_id = _.filter(group, item => item && !isNaN(item)).join(',')
          return
        }
        const groupFilters = filterList[groupKey]
        if (groupFilters?.hidden) {
          return
        }
        _.forEach(group, (filterValue, filterName) => {
          const filter = groupFilters?.filterList[filterName]
          if (!filter || !filterValue) {
            return
          }
          filter.setParam(params, filterValue)
        })
      })
      return params
    },
    async handelSearch (search, nextPage, targetPage) {
      if (nextPage) {
        if (this.pagination.page === this.pagination.totalPage) {
          this.$message.warning(this.$t(`${this.i18nPrefix}.message.noData`))
          return
        }
        this.pagination.page += 1
      } else {
        this.pagination.page = 1
      }
      this.listLoading = true
      if (!search) {
        search = this.search
      } else {
        this.search = search
      }
      const params = this.parseSearchToParams(search)
      this.searchParams = params
      const page = targetPage || this.pagination.page
      const candidateList = []
      const promiseList = _.chain(this.pagination.page).range(page + 1)
        .map((val) => this.getAgencyJobApplicationList({
          jobId: this.jobId,
          params: {
            ...params,
            ...this.extraParams,
            page: val,
            page_size: this.pagination.pageSize
          }
        })).value()
      const respList = await Promise.all(promiseList)
      let totalPage = this.pagination.totalPage
      let candidateTotalCount = this.candidateTotalCount
      let isElcOriginCompany = this.isElcOriginCompany
      _.forEach(respList, resp => {
        if (resp) {
          const vm = this
          totalPage = resp.total_page
          candidateTotalCount = resp.total_count
          isElcOriginCompany = resp.is_elc_origin_company
          _.forEach(resp.data, applicant => {
            applicant.selected = false
            const candidate = applicant.candidate
            candidate.age = candidate.birthday ? moment().diff(candidate.birthday, 'year') : ''
            const hasSolvingProblemFit = candidate.problem_solving_finished && candidate.mental_ability
            const hasPersonalityFit = candidate.personality_finished && (candidate.organization_fit || candidate.job_fit)
            candidate.hasFit = (hasPersonalityFit || hasSolvingProblemFit) || (this.hasAIResumeMatchPermission && applicant.ai_match_info?.resume_ai_match_score)
            Object.defineProperty(candidate, 'maxDegreeI18nName', {
              configurable: true,
              enumerable: true,
              get () {
                const maxDegree = candidate.max_degree
                // TODO: 学历不存在的时候怎么处理，待确认
                return getConstantI18nValue(DEGREE, maxDegree, 'meta.DEGREE')
              }
            })
            Object.defineProperty(candidate, 'candidateStatusName', {
              configurable: true,
              enumerable: true,
              get () {
                let i18nKey = null
                if (candidate.is_alumni) {
                  i18nKey = 'alumni'
                } else if (candidate.is_employee) {
                  i18nKey = 'employee'
                } else {
                  i18nKey = 'candidate'
                }
                if (!applicant.reviewed) {
                  i18nKey += 'New'
                }
                return vm.$t(`${vm.i18nPrefix}.label.${i18nKey}`)
              }
            })
            Object.defineProperty(applicant, 'statusName', {
              configurable: true,
              enumerable: true,
              get () {
                return applicant.status.i18nName || getI18nPropertyValue(applicant.status, 'name_cn', 'name_en')
              },
              set (status) {
                applicant.status = status
              }
            })
            Object.defineProperty(applicant, 'locationI18nName', {
              configurable: true,
              enumerable: true,
              get () {
                const location = applicant.candidate.location
                const province = getI18nPropertyValue(location.province, 'cn_name', 'name')
                const city = getI18nPropertyValue(location.city, 'cn_name', 'name')
                return city || province
              }
            })
            Object.defineProperty(applicant, 'totalWorkYear', {
              configurable: true,
              enumerable: true,
              get () {
                const totalWorkYear = applicant.candidate.total_work_year
                if (!totalWorkYear) {
                  return ''
                }
                let totalWorkYearI18nName = ''
                if (applicant.job.experience_required !== 'N') {
                  if (totalWorkYear < 1) {
                    totalWorkYearI18nName = `${parseInt(totalWorkYear * 12)} ${vm.$t(`${vm.i18nPrefix}.label.month`)}`
                  } else {
                    totalWorkYearI18nName = `${Math.floor(totalWorkYear * 10) / 10} ${vm.$t(`${vm.i18nPrefix}.label.year`)}`
                  }
                }
                return totalWorkYearI18nName
              }
            })
          })
          candidateList.push(...resp.data)
        }
      })
      if (this.pagination.page === 1) {
        this.candidateList = candidateList
      } else {
        this.candidateList.push(...candidateList)
      }
      this.pagination.page = page
      this.pagination.totalPage = totalPage
      this.candidateTotalCount = candidateTotalCount
      this.isElcOriginCompany = isElcOriginCompany
      this.listLoading = false
    },
    handleScrollBottom () {
      this.handelSearch(this.search, true)
    },
    handleOrderChange (prop, order) {
      this.listOrder.prop = prop
      this.listOrder.order = order
      this.candidateList = []
      this.handelSearch(this.search, false)
    },
    handleOpenDetail (rowData) {
      const candidateId = rowData.candidate.id
      const jobId = rowData.job.id
      rowData.reviewed = true
      const params = encodeURIComponent(JSON.stringify(this.parseSearchToParams(this.search)))
      const backUrl = encodeURIComponent(this.$route.fullPath)
      this.loadJobInfo()
      window.open(`
      /v-admin/agency/application/profile?candidate_id=${candidateId}&job_id=${jobId}&list_params=${params}&back=${backUrl}
      `)
    },
    handleScrollToTop (listType) {
      this.$nextTick(() => {
        const candidateListRef = listType === 'table' ? this.$refs.tableContainer : this.$refs.cardContainer
        candidateListRef.scrollToTop && candidateListRef.scrollToTop()
      })
    },
    handleStatusFilter ($event, candidateStage, candidateStatus) {
      this.listLoading = true

      let statusList = []
      if (candidateStage) {
        statusList = _.map(candidateStage.statusList, item => item.key)
      } else if (candidateStatus) {
        statusList = [candidateStatus]
      }

      const search = this.$refs.filterList.search
      const key = FILTER_GROUP_TYPE.APPLICATION_DETAIL
      search[key].candidateStatus = statusList
      search[key]._exclude = _.filter(search[key]._exclude, item => item !== 'candidateStatus')
      this.$refs.filterList.resetSearch({ search })
    },
    handleReadStatusFilter () {
      this.listLoading = true
      const search = this.$refs.filterList.search
      const key = FILTER_GROUP_TYPE.APPLICATION_DETAIL
      const readStatus = READ_STATUS.UNREAD

      search[key].readStatus = readStatus
      this.$refs.filterList.resetSearch({ search })
    },
    handleOpenPotential () {
      this.$router.push(`/v-admin/job/${this.jobId}/potential/list`)
    }
  },
  watch: {
    candidateListLength () {
      if (this.$refs.tableContainer && (this.isSelectedAllCandidate || this.selectAllIsIndeterminate)) {
        this.$refs.tableContainer.refreshSelectAllCandidate()
      }
      if (this.$refs.cardContainer && (this.isSelectedAllCardCandidate || this.selectAllIsIndeterminate)) {
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(this.cancelSelectedCandidateList, candidate) && !candidate.is_agency_uploaded_and_hid) {
            candidate.selected = true
          } else {
            candidate.selected = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  width: 100%;
  height: 100%;

  .applicant-list {
    .nps-chart-container {
      margin-top: 10px;
      padding-bottom: 14px;
      border-bottom: 1px solid #e7eaeb;

      .text {
        display: inline-block;

        .title {
          font-weight: bold;
        }

        .description {
          margin-top: 4px;
          font-size: 12px;

          .text {
            vertical-align: middle;
            color: #606266;
          }

          .tip-icon {
            vertical-align: middle;
            margin-left: 8px;
            font-size: 14px;
            color: #c0c4cc;
            cursor: pointer;
          }
        }
      }

      .nps-chart {
        display: inline-block;
        vertical-align: bottom;
        margin-left: 16px;
        width: 47px;
        height: 47px;
      }
    }

    .last-work {
      margin-top: 6px;
    }

  }

  .rate-dialog {
    ::v-deep {
      .el-dialog {
        margin: auto;

        .el-dialog__body {
          padding: 30px 30px;
        }
      }
    }
  }

  .interview-dialog {
    ::v-deep {
      .el-dialog {
        margin: auto;

        .el-dialog__body {
          padding: 30px 30px;
        }
      }
    }
  }

  .change-candidate-status-dialog {
    ::v-deep {
      .el-dialog__header {
        padding: 34px 40px 0px;
      }

      .el-dialog__body {
        padding: 0px 40px 16px;
      }

      .el-dialog__title {
        font-size: 22px;
        font-weight: 500;
        color: #303133;
      }
    }
  }
}
</style>
<style lang="scss">
.school-popper, .applied-job-popper, .consent-info-popper {
  max-width: 300px;

  .el-select-group__title {
    padding: 0px 20px;
  }

  .label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
